import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { Button } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

// Dummy function for chart display
const StockChart = ({ symbol }) => {
  // You can replace this with your actual charting component or library
  return <div>{`Chart for ${symbol}`}</div>;
};

const Favorites = ({ favorites, stocks, selectedStock, toggleFavorite, setSelectedStock }) => {

  const favoritesStocks = stocks.filter((stock) =>
    favorites.includes(stock.symbol)
  );

  const handleStockSelect = (symbol) => {
    setSelectedStock(symbol); // This should trigger an update in parent component if needed
  };

  const columns = [
    {
      name: 'Symbol',
      selector: (row) => row.symbol,
      sortable: true,
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Price',
      selector: (row) => `$${row.price.toFixed(2)}`,
      sortable: true,
    },
    {
      name: 'Change %',
      selector: (row) => `${row.changePercent.toFixed(2)}%`,
      sortable: true,
    },
    {
      name: 'Volume',
      selector: (row) => row.volume.toLocaleString(),
      sortable: true,
    },
    {
      name: 'Market Cap',
      selector: (row) => `$${row.marketCap.toLocaleString()}`,
      sortable: true,
    },
    {
      name: 'Remove',
      cell: (row) => (
        <>
          {favorites.includes(row.symbol) ? (
            <i
              className="fa fa-star text-success"
              onClick={() => toggleFavorite(row.symbol)}
            ></i>
          ) : (
            <i
              className="fa fa-star"
              onClick={() => toggleFavorite(row.symbol)}
            ></i>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <Card className="my-4">
        <Card.Header className="border-bottom">
          <h2 className="m-0 h5">Favorite Stocks</h2>
        </Card.Header>
        <Card.Body className="px-0 pt-0">
          <DataTable
            columns={columns}
            data={favoritesStocks}
            pagination
            highlightOnHover
            pointerOnHover
            onRowClicked={(row) => handleStockSelect(row.symbol)} // Update selected stock on row click
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default Favorites;
